import React from 'react';
import { IonButton, IonContent, IonFooter, IonSpinner } from '@ionic/react';
import StageBar from 'src/components/StageBar';
import alerts from 'src/lib/alerts';

export default class StageUrl extends React.Component {
  handleStageEnd = () => {
    this.props.nextStage().catch(alerts.errors);
  };

  render() {
    const {
      stage,
      fetching,
      job,
      stageContainer,
      startBreak,
      endBreak
    } = this.props;
    return (
      <React.Fragment>
        <IonContent>
          <StageBar
            job={job}
            stage={stage}
            stageContainer={stageContainer}
            onStartBreak={startBreak}
            onEndBreak={endBreak}
            fetching={fetching}
          />
          {/* <iframe
          title="Stage Url"
          // src={stage.url}
          height={this.imgHeight}
          width={this.imgWidth}
        /> */}
          <div className="text-center p-5">
            <h4>Visit Website</h4>
            <p>
              This stage requires you to visit a website and complete some
              action. After you have visited the site, return to the app and
              continue to the next stage.
            </p>
            <IonButton
              href={stage.url}
              target="_blank"
              rel="noopener noreferrer"
              color="light"
              expand="block"
            >
              Vist Site
            </IonButton>
          </div>
        </IonContent>
        <IonFooter>
          <IonButton
            onClick={this.handleStageEnd}
            disabled={fetching}
            expand="full"
            className="ion-no-margin"
            color="success"
          >
            {fetching ? <IonSpinner /> : 'Next Stage'}
          </IonButton>
        </IonFooter>
      </React.Fragment>
    );
  }
}
